export default function () {
     //console.log("window.innerWidth: " + window.innerWidth)
     if (window.innerWidth >= 1000) {
        $("header .corner").attr("aria-hidden", "false");
      } else {
        $("header .corner").attr("aria-hidden", "true");
      }
}